// extracted by mini-css-extract-plugin
export default {"infoCards":"styles_infoCards__UV8JR","infoCardsItemWrap":"styles_infoCardsItemWrap__vHKzV","hideBlock":"styles_hideBlock__o889u"};